import { Dispatch } from "redux";
import { Pagination, ResponseDetails } from "../../Interfaces/Interfaces";
import { errorHandler } from "../../helpers/Functions";
import TransactionService from "../../services/TransactionService";

export const getTransactions = (data: Pagination) => {
  const api = new TransactionService().getTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getCoordinatorTransactions = (data: Pagination) => {
  const api = new TransactionService().getCoordinatorTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          // console.log(res)
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getTransactionByUser = (data: Pagination) => {
  const api = new TransactionService().getTransactionsByUser(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentTransactions = (data: Pagination) => {
  const api = new TransactionService().getAgentTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorTransactions = (data: Pagination) => {
  const api = new TransactionService().getAggregatorPersonalTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentDashboard = (id: string) => {
  const api = new TransactionService().getAgentDashboard(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getTransactionSummary = (id: string) => {
  const api = new TransactionService().getTransactionSummary(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTION_DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getTransactionSummaryCount = (id: string) => {
  const api = new TransactionService().getTransactionSummaryCount(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTION_COUNT",
            payload: res.items[0],
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const transactionTypes = () => {
  const api = new TransactionService().transactionTypes();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTION_TYPES",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getTransactionDetails = (id: string) => {
  const api = new TransactionService().getTransactionDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_DETAILS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

// customers

export const getCustomerDashboard = (id: string) => {
  const api = new TransactionService().getCustomerDashboard(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const reconfirmTransactions = (data: any) => {
  const api = new TransactionService().reconfirmTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: true,
            },
          });
          dispatch({
            type: "TRANSACTION_DETAILS_STATUS",
            payload: {
              message: res.result,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const sendReconfirmTransactions = (data: any) => {
  const api = new TransactionService().sendreconfirmTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: true,
            },
          });
          dispatch({
            type: "TRANSACTION_DETAILS_MESSAGE",
            payload: {
              message: res.result,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const sendReconfirmTransactionPage = (data: any) => {
  const api = new TransactionService().getReconfirmTransactionMessagePage(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: true,
            },
          });
          dispatch({
            type: "TRANSACTION_DETAILS_MESSAGE",
            payload: {
              message: res.result,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getPerformanceTarget = () => {
  const api = new TransactionService().performanceTarget();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_TARGET",
            payload: res.result,
          });
        } else {
         // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "TRANSACTION_TARGET",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAgentPerformanceTarget = (id: string) => {
  const api = new TransactionService().agentPerformanceTarget(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_TARGET",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorPerformanceTarget = (data:any) => {
  const api = new TransactionService().aggregatorPerformanceTarget(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_TARGET",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
